<template>
    <div class="monitorWeather" >
        <iframe allowtransparency="true" frameborder="0" width="317" height="28" scrolling="no" style="transform:scale(2);" src="//tianqi.2345.com/plugin/widget/index.htm?s=3&z=1&t=1&v=0&d=1&bd=0&k=&f=80ffff&ltf=009944&htf=cc0000&q=1&e=0&a=1&c=54511&w=317&h=28&align=right"></iframe>
    </div>
</template>

<script>
export default {
    name: 'MonitorTopWeather',
    data() {
        return {}
    },
    computed: {
        //当前天气
        // weather() {
        //     return this.$store.state.weather || {}
        // },
        // content() {
        //     return (this.weather.location||'') + '&nbsp;&nbsp;&nbsp;' + (this.weather.weather||'') + '&nbsp;&nbsp;&nbsp;' + (this.weather.temp || 0) + '℃&nbsp;&nbsp;&nbsp;降水量：' + (this.weather.precipitation||0) + 'mm'
        // }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorTopWeather.vue